import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import {
  ActivityHistory,
  ApplyForExam,
  ApplyForTranscript,
  Document,
  DownloadTranscript,
  ExamDeferment,
  Examination,
  ExaminationDisclaimer,
  ForgotPassword,
  ForgotPasswordSuccess,
  Home,
  Induction,
  Login,
  MessageReceived,
  MyDocuments,
  NeedHelp,
  Notification,
  PayDues,
  PaymentHistory,
  PaymentSuccessful,
  PhotoCard,
  Profile,
  Receipt,
  RegisteredExams,
  ResetPassword,
  StatementOfResult,
  StudyCenterLink,
  Transcript,
  TranscriptSummary,
} from "./screens";
import ProtectedRoute from "./hooks/protectedRoute";
// import { useVersionCheck } from "./hooks/useVersionCheck";

function App() {
  // useVersionCheck(60000);
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/examreset-password" element={<ResetPassword />} />
        <Route
          path="/forgot-password-success"
          element={<ForgotPasswordSuccess />}
        />
        <Route path="need-help" element={<NeedHelp />} />
        <Route path="/message-received" element={<MessageReceived />} />

        <Route path="/profile" element={ <ProtectedRoute><Profile /></ProtectedRoute>  } />
        <Route path="/home" element={ <ProtectedRoute><Home /></ProtectedRoute>  } />
        <Route path="/examination" element={ <ProtectedRoute><Examination /></ProtectedRoute> } />
        <Route path="/statement-of-result" element={ <ProtectedRoute><StatementOfResult /></ProtectedRoute> } />
        <Route path="/transcript" element={ <ProtectedRoute><Transcript /></ProtectedRoute>} />
        <Route path="/induction" element={ <ProtectedRoute><Induction /></ProtectedRoute> } />
        <Route path="/exam-deferment" element={ <ProtectedRoute><ExamDeferment /></ProtectedRoute> } />
        <Route path="/pay-dues" element={ <ProtectedRoute><PayDues /></ProtectedRoute> } />
        <Route path="/payment-history" element={ <ProtectedRoute><PaymentHistory /></ProtectedRoute> } />
        <Route path="/payment-history/receipt" element={ <ProtectedRoute><Receipt /></ProtectedRoute> } />
        <Route path="/my-documents" element={ <ProtectedRoute><MyDocuments /></ProtectedRoute> } />
        <Route path="/document" element={ <ProtectedRoute><Document /></ProtectedRoute> } />
        <Route path="/activity-history" element={ <ProtectedRoute><ActivityHistory /></ProtectedRoute> } />
        <Route path="/study-center" element={ <ProtectedRoute><StudyCenterLink /></ProtectedRoute> } />
        <Route path="/transcript/apply" element={ <ProtectedRoute><ApplyForTranscript /></ProtectedRoute> } />
        <Route path="/transcript/summary" element={ <ProtectedRoute><TranscriptSummary /></ProtectedRoute> } />
        <Route path="/registered-exams" element={ <ProtectedRoute><RegisteredExams /></ProtectedRoute> } />
        <Route path="/examination/apply" element={ <ProtectedRoute><ApplyForExam /></ProtectedRoute> }/>
        <Route path="/examination/disclaimer" element={ <ProtectedRoute><ExaminationDisclaimer /></ProtectedRoute>}/>
        <Route path="/payment-successful" element={ <ProtectedRoute><PaymentSuccessful /></ProtectedRoute> }/>
        <Route path="/notification" element={ <ProtectedRoute><Notification /></ProtectedRoute> }/>
        <Route path="/transcript/download" element={<ProtectedRoute><DownloadTranscript /></ProtectedRoute>} />
        <Route path="/photo-card" element={ <ProtectedRoute><PhotoCard /></ProtectedRoute> }/>
      </Routes>
    </Router>
  );
}

export default App;
